/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown>, date: NonNullable<unknown> }} Practice_Attempt_OptionInputs */



/**
* | output |
* | --- |
* | "Attempt {number} · {date}" |
*
* @param {Practice_Attempt_OptionInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_attempt_option = /** @type {((inputs: Practice_Attempt_OptionInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Attempt_OptionInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Poging ${i?.number} · ${i?.date}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Tentative ${i?.number} · ${i?.date}`)
	return /** @type {LocalizedString} */ (`Attempt ${i?.number} · ${i?.date}`)
});